export class SkipToContent {
    constructor(contentID, linkText) {
        this.skipToContentLink = document.createElement("a");
        this.skipToContentLink.tabIndex = 0;
        this.skipToContentLink.className = "skip-to-content";
        this.skipToContentLink.href = contentID;
        this.skipToContentLink.textContent = linkText;
        document.body.insertBefore(this.skipToContentLink, document.body.firstChild);
        this.content = document.querySelector(contentID);
        this.skipToContentLink.addEventListener("click", (e) => this.onSkipToContent(e));
    }
    onSkipToContent(e) {
        if (this.content) {
            this.content.focus();
        }
    }
}
